import styled from "styled-components";

export const SelectComponent = styled.div`
  .select__control {
    padding: 5.67px;
    border: 1px solid ${(props) => props.theme.colors.typography1.dark};
    border-radius: 12px;
    margin-bottom: 28px;
    background-color: transparent;
    color: ${(props) => props.theme.colors.typography1.dark};
    font-size: 0.89rem;
    box-shadow: 0 0 0 1px ${(props) => props.theme.colors.brand1.pure};
    cursor: pointer;

    :hover {
      border: 1px solid ${(props) => props.theme.colors.typography1.dark};
    }

    .select__indicators {
      .select__indicator-separator {
        display: none;
      }
    }

    .select__value-container--has-value {
      .select__single-value {
        color: ${(props) => props.theme.colors.typography1.dark};
      }
    }
  }

  .select__control--is-focused {
    background-color: ${(props) => props.theme.colors.brand1.pure};
  }

  .select__control--is-focused {
    .select__value-container--has-value {
      .select__single-value {
        color: ${(props) => props.theme.colors.typography2.medium};
      }
    }
  }

  .select__menu {
    padding: 14px;
    border: 1px solid ${(props) => props.theme.colors.typography1.dark};
    border-radius: 12px;
    margin-bottom: 28px;
    background-color: ${(props) => props.theme.colors.brand4.medium};
    color: ${(props) => props.theme.colors.typography1.pure};
    font-size: 1rem;
    box-shadow: 0 0 0 1px ${(props) => props.theme.colors.brand1.pure};

    .select__menu-list {
      max-height: 150px;
    }

    .select__option--is-focused {
      background: none;
      opacity: 0.8;
      cursor: pointer;
    }

    .select__option--is-selected {
      color: ${(props) => props.theme.colors.typography2.medium};
      background-color: transparent;
    }
  }

  .select--is-disabled {
    background-color: ${(props) => props.theme.colors.typography2.light};
    border-radius: 12px;
    opacity: 0.8;

    .select__control--is-disabled {
      box-shadow: none;
      border: none;
    }

    .select__value-container--has-value {
      .select__single-value {
        color: ${(props) => props.theme.colors.brand4.medium};
        opacity: 0.8;
      }
    }

    .select__indicators {
      .select__indicator {
        > svg {
          color: ${(props) => props.theme.colors.typography2.medium};
        }
      }
    }
  }
`;